/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ServicesActivationsComponent from './activations.component';

const servicesActivationsModule = angular.module('tinaba.components.services.activations', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('services.activations',
            {
                url: '/activations',
                template: '<services-activations></services-activations>'
            }
        );
})

.component('servicesActivations', ServicesActivationsComponent);

export default servicesActivationsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/activations/activations.js
 **/